import React from 'react';
import { Grid } from '@material-ui/core';
import Garments from '../../objects/garments/garments';
import Garment from '../../objects/garments/garment';
import ListItem from './ListItem';

interface Props {
    data: Garments | null;
    handleOnSubmit: (garment: Garment) => void;
    currentGarmentId: number;
}

const List: React.FC<Props> = ({ data, handleOnSubmit, currentGarmentId }) => {
    return (
        <Grid container justifyContent="space-between">
            {data &&
                data.getItems().map((item: Garment, index) => (
                    <Grid item key={'item-' + item.getIdGarment()}>
                        <ListItem
                            item={item}
                            handleOnSubmit={handleOnSubmit}
                            index={item.getIdGarment()}
                            currentGarmentId={currentGarmentId}
                        />
                    </Grid>
                ))}
        </Grid>
    );
};

export default List;
